import { render, staticRenderFns } from "./IconMenuFourDot.vue?vue&type=template&id=02be17f0"
import script from "./IconMenuFourDot.vue?vue&type=script&lang=js"
export * from "./IconMenuFourDot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports